import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// material
import { Box, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab';
// components
import FormProvider, { RHFTextField } from '../../../components/hook-form';
import ModalPopup from '../../../components/modal-popup/modalpopup';
import AppCache from '../../../services/appcache';
import MastersService from '../../../services/masters.services';
import HelpService from '../../../services/helpandcommunication.service';
import { handleError, ACCESSABLE_VALUE } from '../../../auth/utils';
import ErrormsgPopup from '../../../components/modal-popup/errormsgpopup';
import LoadingProgressBar from '../../../components/Loading-ProgressBar/LoadingProgressBar';
import { MasterPageNames } from '../../common/masternames';
// --------------------------------------------------------------------------------------------------------

DeleteReasonPopup.propTypes = {
    confirm: PropTypes.func,
    masterName: PropTypes.string,
    selectedRow: PropTypes.array,
};
// --------------------------------------------------------------------------------------------------------

const buttonStyle = {
    backgroundColor: 'common.white',
    color: 'common.black',
    border: '1.5px solid',
    borderColor: 'grey.300',
    mr: 1,
    ':hover': {
        backgroundColor: 'common.white',
        boxShadow: 10,
    }
}
// ----------------------------------------------------------------------------------------------------------------

export default function DeleteReasonPopup({ confirm, masterName, selectedRow }) {

    const navigate = useNavigate();
    const [errormsgpopup, setErrormsgpopup] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    const [loading, setLoading] = useState(false);
    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const mastersPageAccess = loggedInUserDetails?.MastersPageAccess?.[0];

    const masterPageName = MasterPageNames?.Masters.find(mastername => mastername.toLowerCase() === masterName.toLowerCase());

    const currentDataTabDeleteDataCreate = mastersPageAccess ? mastersPageAccess[`CurrentDataTabDeleteDataCreate_${masterPageName}`.toLowerCase()] : '1';

    const onClickNo = () => {
        confirm(false);
    };

    const handleErrorConfirm = () => {
        setErrormsgpopup(false);
        setErrormsg('');
        confirm(false);
    }

    const DeleteSchema = Yup.object().shape({
        reason: Yup.string().required('Reason is required').min(20, 'Too Short!'),
    });

    const defaultValues = useMemo(() => ({
        reason: '',
    }), []);

    const methods = useForm({
        resolver: yupResolver(DeleteSchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = (data) => {
        const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
        if (masterName !== "helptopic" && masterName !== "subcategory" && masterName !== "helpcategory" && masterName !== "tags") {
            setLoading(true);
            try {
                const payload = {
                    "masterName": masterName,
                    "operation": "delete",
                    "changedDate": new Date(),
                    "reason": data.reason,
                    "changedBy": currentLoggedInUser.UserId,
                    "ids": selectedRow
                }
                MastersService.DeleteMasterAndHistoryRecords(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            console.log('Deleted')
                            setLoading(false);
                            confirm(true);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error")
                            setLoading(false);
                        }
                    })
                    .catch(_error => {
                        handleError(_error, navigate, "", setLoading);
                    });
            }
            catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }

        if (masterName === "helptopic") {
            setLoading(true);
            try {
                const payload = {
                    "HelpTopicIds": selectedRow
                }

                HelpService.DeleteIds(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            console.log('Deleted')
                            setLoading(false);
                            confirm(true);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error")
                            setLoading(false);
                        }
                    })
                    .catch(_error => {
                        handleError(_error, navigate, "", setLoading);
                    });
            }
            catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }

        if (masterName === "subcategory") {
            setLoading(true);
            try {
                const payload = {
                    "HelpSubCategoryIds": selectedRow
                }

                HelpService.DeleteSubCategories(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            setLoading(false);
                            confirm(true);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error");
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(response.data);
                        }
                    })
                    .catch(_error => {
                        console.log("Error", _error);
                        if (_error?.response?.status !== 400) {
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(_error.response.data);
                        }
                        else {
                            handleError(_error, navigate, "", setLoading);
                        }
                    });
            }
            catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }

        if (masterName === "helpcategory") {
            setLoading(true);
            try {
                const payload = { helpCategoryIds: selectedRow }
                HelpService.DeleteHelpCategories(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            console.log('Deleted')
                            setLoading(false);
                            confirm(true);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error")
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(response.data);
                        }
                    })
                    .catch(_error => {
                        console.log("Error", _error);
                        if (_error?.response?.status !== 400) {
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(_error.response.data);
                        }
                        else {
                            handleError(_error, navigate, "", setLoading);
                        }
                    });
            }
            catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }

        if (masterName === "tags") {
            setLoading(true);
            try {
                const payload = { helpTagIds: selectedRow }
                HelpService.DeleteHelpTags(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            console.log('Deleted')
                            setLoading(false);
                            confirm(true);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error")
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(response.data);
                        }
                    })
                    .catch(_error => {
                        console.log("Error", _error);
                        if (_error?.response?.status !== 400) {
                            setLoading(false);
                            setErrormsgpopup(true);
                            setErrormsg(_error.response.data);
                        }
                        else {
                            handleError(_error, navigate, "", setLoading);
                        }
                    });
            }
            catch (error) {
                console.error('error', error);
                setLoading(false);
            }
        }
    };

    return (
        <div>
            <ModalPopup cancel={onClickNo} title='Reason for Delete' sx={{ left: '50%', transform: 'translate(-50%,-50%)', width: 400, height: 250 }} >
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <RHFTextField name="reason" label="Reason" multiline rows={6}
                        sx={{ mt: 1, ".MuiOutlinedInput-root": { height: 120 } }} />

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button variant="contained" onClick={onClickNo} sx={buttonStyle}> No  </Button>

                        {currentDataTabDeleteDataCreate === ACCESSABLE_VALUE ?
                            (
                                <LoadingButton className="loadingButton" type="submit" variant="contained" loading={isSubmitting}>
                                    Yes
                                </LoadingButton>
                            ) : (
                                <LoadingButton className="loadingButton" disabled="true" variant="contained" >
                                    Yes
                                </LoadingButton>
                            )
                        }
                    </Box>
                </FormProvider>
            </ModalPopup>

            {loading && <LoadingProgressBar />}

            {errormsgpopup && <ErrormsgPopup confirm={handleErrorConfirm} msg={errormsg} header="Error" />}
        </div >
    )
}